import loadable from "@loadable/component";
import { useNavigate } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";

const CreateManifestComponent = loadable(
  () => import("../../components/CourierDispatchManifest/CreateManifest")
);

const CreateManifest = () => {
  const navigate = useNavigate();
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["manifest"],
  });

  const { data, isLoading } = useGetHook({
    queryKey: ["branch"],
    url: APIS.BRANCH,
    params: {
      is_main_branch: true,
    },
  });
  const { mutateAsync: addVehicle, isPostLoading: isVehicleLoading } =
    usePostHook({
      queryKey: ["vehicle"],
      navigateURL: "",
    });
  const { mutateAsync: addDriver, isPostLoading: isDriverLoading } =
    usePostHook({
      queryKey: ["riders"],
      navigateURL: "",
    });

  const handleAddDriver = async (values: any, setError: any) => {
    const url = `${APIS.DRIVER_CREATE}`;
    let formData = {
      ...values,
      username: values?.username ?? null,
      email: values?.email ?? null,
      mobile_number: `+977${values?.mobile_number}`,
    };
    try {
      await addDriver({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };
  const handleAddVehicle = async (values: any, setError: any) => {
    const url = `${APIS.VEHICLE}`;
    let formData = {
      ...values,

      emergency_contact_number: values?.emergency_contact_number,
      insurance_company_contact_number:
        values?.insurance_company_contact_number,
      samiti_contact_number: values?.samiti_contact_number,
    };
    try {
      await addVehicle({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.MANIFEST}`;
    let formData = {
      ...values,
      allowed_cities:
        values?.allowed_cities && values?.allowed_cities?.length > 0
          ? values?.allowed_cities?.map((item: any) => item?.value)
          : [],
      type: "manifest",
    };

    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status == 201) {
        navigate(`/edit/${res?.data?.id}`);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Manifest
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <CreateManifestComponent
          isLoading={isPostLoading}
          handleCreate={handleCreate}
          handleAddVehicle={handleAddVehicle}
          isVehicleLoading={isVehicleLoading}
          handleAddDriver={handleAddDriver}
          isDriverLoading={isDriverLoading}
          data={data}
        />
      )}
    </>
  );
};
export default CreateManifest;
